module.exports = __webpack_public_path__ + "media/images/logo-email-3c0c282e.png";